module.exports = __webpack_public_path__ + "static/media/upload.ac647772.svg";